import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE } from "../../site.config";

const LAYOUTS = [
  "col-span-12 md:col-span-8 aspect-[16/9]",
  "col-span-6 md:col-span-4 aspect-square",
  "col-span-6 md:col-span-4 aspect-square",
  "col-span-12 md:col-span-8 aspect-[16/9]",
  "col-span-6 md:col-span-6 aspect-[4/3]",
  "col-span-6 md:col-span-6 aspect-[4/3]",
  "col-span-12 md:col-span-8 aspect-[16/9]",
  "col-span-6 md:col-span-4 aspect-square",
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-black py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-cyan-pz" />
              <span className="bebas text-cyan-pz tracking-[0.3em] text-sm">
                REAL CUSTOMER JOBS
              </span>
            </div>
            <h2 className="bebas text-white text-5xl md:text-7xl leading-[0.9]">
              FROM THE <span className="text-cyan-pz">WORKSHOP.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md barlow">
            Real jobs finished at our Kunda Park workshop — dual battery installs, REDARC Tow-Pro fitments, UHF, spotlights, A/C service and performance electrical diagnostics.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-3 md:gap-4">
          {SITE.gallery.map((item, i) => {
            const src = typeof item === "string" ? item : item.src;
            const alt =
              typeof item === "string"
                ? `Powerz Auto Electrical workshop — real completed job ${i + 1} — Kunda Park Sunshine Coast`
                : item.alt;
            const caption = typeof item === "string" ? null : item.caption;
            return (
              <figure
                key={src}
                data-testid={`gallery-item-${i}`}
                className={`relative overflow-hidden border border-white/10 group ${LAYOUTS[i] || "col-span-6 aspect-square"}`}
              >
                <img
                  src={src}
                  alt={alt}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[15%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
                {caption && (
                  <figcaption
                    data-testid={`gallery-caption-${i}`}
                    className="absolute inset-x-0 bottom-0 p-4 md:p-5"
                  >
                    <p className="bebas text-white tracking-widest text-sm md:text-base group-hover:text-cyan-pz transition-colors">
                      {caption}
                    </p>
                  </figcaption>
                )}
                <span className="absolute top-3 left-3 bebas text-cyan-pz/70 tracking-widest text-xs">
                  / {String(i + 1).padStart(2, "0")}
                </span>
              </figure>
            );
          })}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Link
            to="/builds"
            data-testid="gallery-all-builds-link"
            className="inline-flex items-center gap-3 border border-cyan-pz/50 text-cyan-pz px-6 py-3 bebas text-base tracking-[0.2em] hover:bg-cyan-pz hover:text-black transition-colors"
          >
            SEE ALL 26 COMPLETED BUILDS
            <ArrowRight className="w-4 h-4" />
          </Link>
          <p className="text-white/50 barlow text-sm">
            Every photo above is a real customer vehicle finished at our Kunda Park workshop.
          </p>
        </div>
      </div>
    </section>
  );
}
